"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13.71 7.29l-5-5C8.53 2.11 8.28 2 8 2s-.53.11-.71.29l-5 5A1.003 1.003 0 003 9h2v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V9h2a1.003 1.003 0 00.71-1.71z"];
//# sourceMappingURL=key-shift.js.map